import React, { useState, useContext } from "react";
import axios from "axios";
import { Button } from "reactstrap";

import Swal from "sweetalert2";
import { AuthContext } from "../contexts/AuthContext";

function Status(props) {
  const { user } = useContext(AuthContext);
  const [text, setText] = useState(false);
  const URL_STATUS = `${props.URL_STATUS}/${props.idStatus}`;
  const URL_BAJA_HIJO = `${props.hijo}/${props.idStatus}`;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;

  function abierto() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Abrirá!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Abrir!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_STATUS,
            {
              status: "Abierto",
              surtido: "No"
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
            .patch(
              URL_BAJA_HIJO,
              {
                is_active: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            ).then(()=>{
              axios.post(
                URL_LOGS,
                {
                  tipo: "Abrir Surtido",
                  detalle: `${props.idStatus}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Se Abrió",
                showConfirmButton: false,
                timer: 2000,
              });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
              });
              console.log(error);
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  function cerrar() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrará y se liberara el inventario!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_STATUS,
            {
              status: "Cerrado",
              surtido: "Si",
              // autorizadoApartado: "No",
              // autorizadoSurtido: "No"
              // No estoy seguro si hay q poner esto o no tanto en el papa como en el hijo...
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
            .patch(
              URL_BAJA_HIJO,
              {
                is_active: "No",
                // autorizadoApartado: "No",
                // autorizadoSurtido: "No"
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            ).then(()=>{
              axios.post(
                URL_LOGS,
                {
                  tipo: "Cerrar Surtido",
                  detalle: `${props.idStatus}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Se Cerró",
                showConfirmButton: false,
                timer: 2000,
              });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
              });
              console.log(error);
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  return (
    <>
      {props.status == "No" ? (
        <span>
          <Button
            color="primary"
            id="Cerrar"
            onClick={cerrar}
            size="sm"
          >
          <i className="fas fa-lock-open"></i>
          </Button>
        </span>
      ) : (
        <span>
          <Button color="danger" onClick={abierto} size="sm">
            <i className="fas fa-lock"></i>
          </Button>
        </span>
      )}
    </>
  );
}

export default Status;

